import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./assets/locales/en/translation.json";
import translationFR from "./assets/locales/fr/translation.json";
import { DEFAULT_LANGUAGE, USER_SETTINGS } from "./utils/constants";

const SESSION_KEY = "session";

// Language stored in the session's user settings. Returns null when there is none, including an empty
// session after logout, so the current language is kept (the login page stays in the user's language).
const getSessionLanguage = (session) => session?.settings?.[USER_SETTINGS.LANGUAGE] || null;

const getInitialLanguage = () => {
    try {
        const saved = localStorage.getItem(SESSION_KEY);
        return (saved && getSessionLanguage(JSON.parse(saved))) || DEFAULT_LANGUAGE;
    } catch (e) {
        return DEFAULT_LANGUAGE;
    }
};

// Switch to the given language (default when none). Also used by token-only pages (PowerPoint add-in),
// which read the language claim from their query-string token.
export const applyLanguage = (language) => {
    const next = language || DEFAULT_LANGUAGE;
    if (next !== i18n.language) {
        i18n.changeLanguage(next);
    }
};

// Called whenever the session is written (login, settings save, logout, ...).
export const applySessionLanguage = (session) => {
    const language = getSessionLanguage(session);
    if (language) {
        applyLanguage(language);
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: translationEN },
            fr: { translation: translationFR },
        },
        lng: getInitialLanguage(),
        fallbackLng: DEFAULT_LANGUAGE,
        interpolation: {
            escapeValue: false,
        },
    });

// Keep other open tabs in sync when the session changes there.
window.addEventListener("storage", (e) => {
    if (e.key !== SESSION_KEY) {
        return;
    }
    try {
        applySessionLanguage(e.newValue ? JSON.parse(e.newValue) : {});
    } catch (err) {
        // ignore malformed session values
    }
});

export default i18n;
